import React, { useEffect, useState, forwardRef } from "react";
import Select from "antd/es/select/index";
import FormItem from "antd/es/form/FormItem";
import Row from "antd/es/row/index";
import Col from "antd/es/col/index";

const SelectOption = Select.Option;

export default forwardRef((props: any, ref: any) => {
  const { form, inputData, questionsKey, language, onCheckAnswer, checkAnswer } = props,
    { required, questions, defaultValue, id, options } = inputData,
    { getFieldDecorator } = form;
  const [value, setValue] = useState('');

  useEffect(() => {
    if (checkAnswer) {
      const option = options.find((option:any)=>option.value==value) as any || '';
      if (option) {
        onCheckAnswer(id, option.text[language], questionsKey);
      } else {
        onCheckAnswer(id, '', questionsKey);
      }
    }
  }, [checkAnswer]);

  return (
    <Row type="flex" justify="center">
      <Col span={16}>
        <FormItem
          colon={false}
          label={
            <label
              dangerouslySetInnerHTML={{
                __html: questions[language] || "no question for selected language"
              }}
            />
          }
        >
          {getFieldDecorator(id, {
            initialValue: defaultValue,
            rules: [
              {
                required,
                message: "Required Field"
              }
            ]
          })(
            <Select disabled={checkAnswer} onChange={setValue}>
              {options.map((option: any) => {
                return (
                  <SelectOption
                    value={option.value}
                    // on long answers removes "..." and makes break line, makes possible to see all answer
                    style={{ whiteSpace: "normal" }}
                    key={option.value}
                  >
                    {option.text[language]}
                  </SelectOption>
                );
              })}
            </Select>
          )}
        </FormItem>
      </Col>
    </Row>
  );
});
